import React from 'react'
import Chip from 'material-ui/Chip'
import { FormattedMessage } from 'react-intl'

const PlanHeading = (props) => (
  <div className='flex items-center mt2 flex-column mb2'>
    <div className='mb2'>
      <Chip
        backgroundColor={(props.plan === '無料') ? '#4688F1' : (props.plan === 'starter') ? '#FFC514' : '#C347E1'}>
        <div
          style={{fontSize: 12}}
          className='white ttu'>
          {props.plan}
        </div>
      </Chip>
    </div>
    <div>
      {(props.plan === '無料') ? (
        ''
      ) : (props.plan === 'starter' || 'premium') ? (
        <div className='mb2'>
        <span
          style={{fontSize: 20}}
          className='ttu'>¥{'2,000'} </span>
          <span style={{fontSize: 12, color: '#BBBBBB'}}>
          <FormattedMessage id='planHeading.per'/>{props.contract}
        </span>
        </div>
      ) : ''}
      <div
        className='mb2'
        style={{fontSize: 12, color: '#BBBBBB'}}>
        {(props.plan === '無料') ? (
          ''
        ) : (props.plan === 'starter') ? (
          <FormattedMessage id='planHeading.monthly'/>
        ) : (props.plan === 'premium') ? (
          <FormattedMessage id='planHeading.yearly'/>
        ) : ''}
      </div>
      <div
        className='ttu'
        style={{fontSize: 12, color: '#BBBBBB'}}>
        {(props.plan === '無料') ? (
          <FormattedMessage id='planHeading.freeHeading'/>
        ) : (props.plan === 'starter') ? (
          <FormattedMessage id='planHeading.starterHeading'/>
        ) : (props.plan === 'premium') ? (
          <FormattedMessage id='planHeading.premiumHeading'/>
        ) : ''}
      </div>
    </div>
  </div>
)

export default PlanHeading



// WEBPACK FOOTER //
// ./src/routes/ManagePlans/Plans/PlanHeading.js